export default {
    filters: {
        max_char(value, arg1) {
            if (!value) {
                return '';
            }
            if (value.length > arg1) {
                return value.slice(0, arg1) + '...';
            } else {
                return value;
            }
        },
    },
}
